import { render, staticRenderFns } from "./Extract.vue?vue&type=template&id=5cf3fdd6&scoped=true"
import script from "./Extract.vue?vue&type=script&lang=js"
export * from "./Extract.vue?vue&type=script&lang=js"
import style0 from "./Extract.vue?vue&type=style&index=0&id=5cf3fdd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf3fdd6",
  null
  
)

export default component.exports